import { render, staticRenderFns } from "./CoursePackageList.vue?vue&type=template&id=91babf12&scoped=true"
import script from "./CoursePackageList.vue?vue&type=script&lang=js"
export * from "./CoursePackageList.vue?vue&type=script&lang=js"
import style0 from "./CoursePackageList.vue?vue&type=style&index=0&id=91babf12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91babf12",
  null
  
)

export default component.exports